import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "down--sprite",
  "use": "down--sprite-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"down--sprite\">\n<path d=\"M5.16699 6.8335L8.50033 10.1668L11.8337 6.8335H5.16699Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol